import { ComponentType } from 'react'
import WelcomePage from '@/views/pages/WelcomePage'
import WelcomePageOIDC from '@/views/pages/WelcomePageOIDC'
import RegistrationPage from '@/views/pages/RegistrationPage'
import RegistrationPageOIDC from '@/views/pages/RegistrationPageOIDC'
import FamilyPage from '@/views/pages/FamilyPage'
import SummaryPage from '@/views/pages/SummaryPage'
import EligibilityPage from '@/views/pages/EligibilityPage'
import AboutYouPage from '@/views/pages/AboutYouPage'

const stepToComponentMap: (
  isOIDC: boolean
) => { [key: string]: ComponentType } = (isOIDC = false) => ({
  welcome: isOIDC ? WelcomePageOIDC : WelcomePage,
  registration: isOIDC ? RegistrationPageOIDC : RegistrationPage,
  aboutYou: AboutYouPage,
  family: FamilyPage,
  summary: SummaryPage,
  eligibility: EligibilityPage,
})

const stepToTrackingNameMap: { [key: string]: string } = {
  welcome: 'onboarding/welcome',
  registration: 'signup/start',
  aboutYou: 'signup/start',
  family: 'signup/add-family',
  summary: 'signup/thank-you',
  eligibility: 'identity/insurance-details',
}

export { stepToComponentMap, stepToTrackingNameMap }
